import React from 'react'

import { Suggestion } from '@components/common/Suggestion'
import { useShopStage } from '@hooks'
import { DownloadCreatorApp } from '@modules/Dashboard/Home/modules/DownloadCreatorApp'

import type { Recommendation } from '../../../Recommendations.types'
import { Award } from '../../../components/Award/Award'
import { useCampaignStatus } from '../../../hooks/useCampaignStatus'
import { useRecommendationsDismiss } from '../../../hooks/useRecommendationsDismiss'
import downloadFourthwallsCreatorApp from '../assets/download-fourthwalls-creator-app.png'

const ID = 'creatorApp'

export const useCreatorAppRecommendation = () => {
  const { recommendationsDismiss, createOnDismiss } = useRecommendationsDismiss()
  const { shopStage, isLoading: isLoadingShopStage } = useShopStage()
  const { activeIncentives } = useCampaignStatus()
  const incentive = activeIncentives.find((i) => i.recommendationId === ID)

  return {
    creatorAppRecommendation: {
      id: ID,
      enabled: shopStage.stage2 && recommendationsDismiss.creatorApp.visible,
      isLoading: isLoadingShopStage,
      suggestion: (
        <Suggestion
          title="Download Fourthwall's creator app"
          description="Manage your account on the go and send thank you videos to supporters."
          content={<DownloadCreatorApp analytics="downloadCreatorApp" />}
          imageUrl={downloadFourthwallsCreatorApp}
          onDismiss={createOnDismiss(recommendationsDismiss.creatorApp.dismiss)}
          award={
            incentive ? (
              <Award value={incentive.incentive.bonus.value} currency="USD" text="sample credit" />
            ) : undefined
          }
        />
      ),
    } satisfies Recommendation,
  }
}
